export default {
  // 新增车辆出厂管理
  insertPaVehicleOut: '/ygsjzs/paVehicleOut/insertPaVehicleOut',
  // 审批车辆出厂管理
  updatePaVehicleOut: '/ygsjzs/paVehicleOut/updatePaVehicleOut',
  // 删除车辆出厂管理
  deletePaVehicleOut: '/ygsjzs/paVehicleOut/deletePaVehicleOut',
  // 查询车辆出厂管理详情'
  selectPaVehicleOutByRecordId: '/ygsjzs/paVehicleOut/selectPaVehicleOutByRecordId',
  // 分页查询车辆出厂管理列表

  selectPaVehicleOutByPage: '/ygsjzs/paVehicleOut/selectPaVehicleOutByPage'

}
